import gql from 'graphql-tag';
import fragments from './fragments';

export const USER_QUERY = gql`
  query MyUser {
    user {
      ...UserFields
    }
  }
  ${fragments.user}
`;

export const ALL_USERS_QUERY = gql`
  query AllUsers {
    allUsers {
      userId
      email
      userName
      displayName
      isAdmin
      isLockedOut
    }
  }
`;

export const GET_COMMUNITY_MESSAGES_QUERY = gql`
  query MyGetCommunityMessages($input: GetCommunityMessages!) {
    communityMessages(input: $input) {
      messages {
        ...CommunityMessageFields
      }
    }
  }
  ${fragments.communityMessage}
`;

export const ALL_CHAT_MESSAGES_QUERY = gql`
  query MyGetAllChatMessages($input: GetChatMessages!) {
    chatMessages(input: $input) {
      id
      room
      message
      created
      author {
        userId
        email
        userName
        displayName
        isAdmin
      }
    }
  }
`;

export const GET_EVENTS_FOR_USER_QUERY = gql`
  query MyGetEventsForUser($input: GetEventsForUser!) {
    eventsForUser(input: $input) {
      id
      cm {
        userId
        userName
      }
      event
      message
      created
    }
  }
`;

export const GET_GAMES_QUERY = gql`
  query GetGames {
    games {
      games {
        ...Game
      }
    }
  }
  ${fragments.game}
`;



// WEBPACK FOOTER //
// ./src/utils/graphql/queries.js